import { apiSlice } from "./apiSlice";

export const usersRoleSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all role list
        getUserRoleList: builder.query({
            query: (params) => ({
                url: `Roles`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllUsersRole"],
        }),

        // Create new role
        createUserRole: builder.mutation({
            query: ({ body }) => ({
                url: `Roles`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllUsersRole"],
        }),

        // Update role
        updateUserRole: builder.mutation({
            query: ({ body }) => ({
                url: `Roles`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["AllUsersRole"],
        }),

        // Delete role
        deleteUserRole: builder.mutation({
            query: (id) => ({
                url: `Roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["AllUsersRole"],
        }),

        assignPermission: builder.mutation({
            query: (body) => ({
                url: 'RolePermission/assign',
                method: 'POST',
                body: body,
            }),
        }),
        getCheckRolePermission: builder.query({
            query: (roleId) => ({
                url: `RolePermission/role/${roleId}`
            }),
            // providesTags: ["RoleList"],
        }),
        // get user detail byemail
        getByEmail: builder.query({
            query: (email) => ({
                url: `Account/getbyemail`,
                params: { email },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        // get user assets
        getUserAssets: builder.query({
            query: (params) => ({
                url: `Account/user/assets`,
                params
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    })
})

export const { useGetUserRoleListQuery,
    useLazyGetUserRoleListQuery,
    useCreateUserRoleMutation,
    useUpdateUserRoleMutation,
    useDeleteUserRoleMutation,
    useAssignPermissionMutation,
    useLazyGetCheckRolePermissionQuery,
    useGetByEmailQuery,
    useGetUserAssetsQuery,
} = usersRoleSlice;
